import { dispatch } from 'lib/store'
import log from 'lib/log'
import apiClient from 'lib/api-client'
import {
  SET_API_KEYS,
  SET_FETCHING_API_KEYS,
  SET_CREATING_API_KEY,
} from 'constants/action-types'
import type { ApiKey, ApiKeyRole } from 'types/settings/api-keys'

const API_KEYS_QUERY = `
  query {
    apiKeys {
      id
      name
      keyPrefix
      role
      createdAt
    }
  }
`

interface ApiKeysResponse {
  data: {
    apiKeys: ApiKey[]
  }
}

export const fetchApiKeys = async (): Promise<void> => {
  dispatch(SET_FETCHING_API_KEYS, true)

  try {
    const response = await apiClient.post<ApiKeysResponse>('/graphql', {
      query: API_KEYS_QUERY,
    })

    dispatch(SET_API_KEYS, response.data.data.apiKeys)
  } finally {
    dispatch(SET_FETCHING_API_KEYS, false)
  }
}

const CREATE_API_KEY_MUTATION = `
  mutation CreateApiKey($input: CreateApiKeyInput!) {
    createApiKey(input: $input) {
      id
      name
      key
      keyPrefix
      role
      createdAt
    }
  }
`

interface CreateApiKeyResponse {
  data: {
    createApiKey: ApiKey & { key: string }
  }
}

export const createApiKey = async (
  name: string,
  role: ApiKeyRole,
): Promise<string | null> => {
  dispatch(SET_CREATING_API_KEY, true)

  try {
    const response = await apiClient.post<CreateApiKeyResponse>('/graphql', {
      query: CREATE_API_KEY_MUTATION,
      variables: { input: { name, role } },
    })

    const fullKey = response.data.data.createApiKey.key

    log.info('API key created', { name, role })
    await fetchApiKeys()

    return fullKey
  } finally {
    dispatch(SET_CREATING_API_KEY, false)
  }
}

const DELETE_API_KEY_MUTATION = `
  mutation DeleteApiKey($id: ID!) {
    deleteApiKey(id: $id)
  }
`

export const deleteApiKey = async (id: string): Promise<void> => {
  await apiClient.post('/graphql', {
    query: DELETE_API_KEY_MUTATION,
    variables: { id },
  })

  log.info('API key deleted')
  await fetchApiKeys()
}
